/* eslint-disable react/no-children-prop */
/* eslint-disable react/prop-types */
//disable linting due to some code belong to react markdown library
import { Typography } from '@mui/material';
import React from 'react';
import ReactMarkdown from 'react-markdown';
import LoggingService from '../../Services/LoggingService';
import CustomLink from '../Link/CustomLink';
import CustomImg from '../../SharedComponents/CustomImage/CustomImg';
import { LinkCallBacks } from './CustomTypography';
import './TypographyStyle.scss';

export const TypographyStyle = {
    aqua: 'aqua',
    red: 'red',
    orange: 'orange',
    black: 'black',
    link: 'link',
    lightbrown: 'lightbrown',
    redorange: 'redorange',
};

function mapStyleToCss(style: string): string {
    let cssStyle = '';
    Object.entries(TypographyStyle).forEach(([key, value]) => {
        if (key === style) {
            cssStyle = value;
        }
    });
    if (!cssStyle) {
        LoggingService.warn({
            componentName: Typography.name,
            args: ['Undefined style is found in translation file.'],
        });
    }
    return cssStyle;
}

export function createTypoFromStyle(
    text: string,
    linkCallBacks?: LinkCallBacks
): JSX.Element {
    function validURL(link: string | undefined): boolean {
        if (link?.match(/^(tel:|mailto:)/)) return true;

        const pattern = new RegExp(
            '^(https?:\\/\\/)?' + // protocol
                '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain
                '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR IPv4
                '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
                '(\\?[;&a-z\\d%_.~+=-]*)?' + // query
                '(\\#[-a-z\\d_]*)?$', // fragment
            'i'
        );
        return !!link && pattern.test(link);
    }

    const renderTypography = (
        <ReactMarkdown
            components={{
                p: ({ children, ...props }) => <div {...props}>{children}</div>,

                em: ({ children, ...props }) => (
                    <em {...props} style={{ fontSize: '0.9rem' }}>
                        {children}
                    </em>
                ),

                h3: ({ children, ...props }) => (
                    <div className="customSubHeading" {...props}>
                        {children}
                    </div>
                ),

                a: ({ href, title, children, ref: _ref, ...props }) => {
                    const handleClick = async () => {
                        const callbackMatch =
                            href?.match(/callback_[a-zA-Z0-9_-]+$/i) ||
                            title?.match(/callback_[a-zA-Z0-9_-]+$/i);

                        const callbackName = callbackMatch
                            ? callbackMatch[0].split('_')[1]
                            : '';

                        if (callbackName && linkCallBacks?.[callbackName]) {
                            await linkCallBacks[callbackName]();
                        } else {
                            LoggingService.error({
                                componentName: 'CustomTypography',
                                args: [
                                    `Invalid callback with name: ${callbackName}`,
                                ],
                            });
                        }
                    };

                    return (
                        <CustomLink
                            href={validURL(href) ? href : undefined}
                            onClick={handleClick}
                            {...props}
                        >
                            {children}
                        </CustomLink>
                    );
                },

                code: ({ className, children, ...props }) => {
                    const childText = String(children).trim();

                    if (childText.includes('{') && childText.includes('}')) {
                        const cssClass = childText
                            .substring(0, childText.indexOf('{'))
                            .trim();
                        const content = childText
                            .substring(
                                childText.indexOf('{') + 1,
                                childText.indexOf('}')
                            )
                            .trim();

                        return (
                            <span
                                className={mapStyleToCss(cssClass)}
                                {...props}
                            >
                                {content}
                            </span>
                        );
                    }

                    return (
                        <code className={className} {...props}>
                            {children}
                        </code>
                    );
                },

                img: ({ alt, ...props }) => (
                    <CustomImg
                        imgType="iconSmall"
                        {...props}
                        id={alt}
                        className="iconInText"
                    />
                ),
            }}
        >
            {text}
        </ReactMarkdown>
    );

    return <>{renderTypography}</>;
}
